import { MsChevron as o } from "@sunrise/icons";
import { defineComponent as e } from "vue";
const r = e({
  name: "CsSwiper",
  components: {
    MsChevron: o
  }
});
export {
  r as default
};
